// The Slack consent round trip (Connect, Reconnect, or a new channel that
// needs one more permission) leaves the admin for Slack's page and comes
// back to /admin/alert-routing/connect/:provider (connect-return.js). What
// the person was doing waits here until then: the page to come back to, the
// target they were filling in (its name and plain config: never a secret)
// and a channel they asked for. This tab only (sessionStorage), for at most
// 15 minutes. A browser that refuses storage just comes back to Targets.
export const PENDING_KEY = 'edxr.alertRouting.connectPending'
export const PENDING_TTL = 15 * 60 * 1000

// Only a page of alert routing is a way back.
const safeReturn = to => (typeof to === 'string' && /^\/admin\/alert-routing(?:[/?]|$)/.test(to) ? to : null)

export const savePending = ({ provider, purpose, returnTo, draft, newChannel }) => {
  try {
    const record = { provider, purpose, returnTo: safeReturn(returnTo), draft: draft || null, newChannel: newChannel || null, savedAt: Date.now() }
    sessionStorage.setItem(PENDING_KEY, JSON.stringify(record))
    return true
  } catch (e) {
    return false
  }
}

const read = () => {
  const raw = sessionStorage.getItem(PENDING_KEY)
  if (!raw) return null
  let v = null
  try {
    v = JSON.parse(raw)
  } catch (e) {
    v = null
  }
  const fresh = v && typeof v === 'object' && typeof v.provider === 'string' && typeof v.savedAt === 'number' && Date.now() - v.savedAt <= PENDING_TTL
  if (!fresh) {
    sessionStorage.removeItem(PENDING_KEY)
    return null
  }
  return { ...v, returnTo: safeReturn(v.returnTo) }
}

// The record, left in place (the return page's Connect again reuses it).
export const peekPending = () => {
  try {
    return read()
  } catch (e) {
    return null
  }
}

// The record, removed: a consent that finished uses it once.
export const takePending = () => {
  try {
    const v = read()
    sessionStorage.removeItem(PENDING_KEY)
    return v
  } catch (e) {
    return null
  }
}

// Off to the provider's consent page (a full-page navigation: it is another
// site). One place, so tests can stand in for it.
export const leaveFor = url => window.location.assign(url)
